/**
 * Revelação suave das secções à medida que entram no ecrã.
 *
 * Princípio principal: **nunca esconder nada que já esteja visível**. Só os
 * elementos que estão abaixo da dobra no momento em que são montados é que
 * ficam preparados para animar; tudo o resto aparece de imediato. Assim uma
 * ligação lenta, um erro de JS ou um leitor de ecrã nunca apanham a página
 * em branco — o pior caso é não haver animação nenhuma.
 *
 * Respeita `prefers-reduced-motion` e usa um MutationObserver para apanhar o
 * que o React monta depois (mudanças de página, dados a carregar), o que evita
 * ter de ligar isto página a página.
 */

const SELETOR = '.reveal'
const ARMADO = 'reveal-armed'
const VISIVEL = 'is-visible'

// Margem abaixo da dobra: elementos quase visíveis não vale a pena animar.
const MARGEM = 0.85

let iniciado = false

export function startScrollReveal() {
  if (iniciado) return
  if (typeof window === 'undefined' || typeof document === 'undefined') return

  const reduzido =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  if (reduzido || !('IntersectionObserver' in window) || !('MutationObserver' in window)) return

  iniciado = true

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return
        entry.target.classList.add(VISIVEL)
        observer.unobserve(entry.target)
      })
    },
    { rootMargin: '0px 0px -6% 0px', threshold: 0.02 }
  )

  const preparar = (el) => {
    if (el.classList.contains(ARMADO) || el.classList.contains(VISIVEL)) return
    const caixa = el.getBoundingClientRect()
    // Já visível (ou sem dimensão ainda) → fica como está, sem animação.
    if (caixa.height === 0 || caixa.top < window.innerHeight * MARGEM) return
    el.classList.add(ARMADO)
    observer.observe(el)
  }

  const varrer = (raiz) => {
    if (!raiz || raiz.nodeType !== 1) return
    if (raiz.matches && raiz.matches(SELETOR)) preparar(raiz)
    if (raiz.querySelectorAll) raiz.querySelectorAll(SELETOR).forEach(preparar)
  }

  varrer(document.body)

  new MutationObserver((mutations) => {
    mutations.forEach((m) => m.addedNodes.forEach(varrer))
  }).observe(document.body, { childList: true, subtree: true })
}

export default startScrollReveal
